import loadable from '@loadable/component';
import { WithLazyHydration } from '../../../WithLazyHydration';

const TagListLoadable = loadable(() => import('./TagList'), {
  resolveComponent: components => components.TagList
});

export const TagList = WithLazyHydration(TagListLoadable, {
  name: 'TagList'
});
